import { useState } from 'react'
import { Editor, EditorState } from 'draft-js'
import { stateToHTML } from 'draft-js-export-html'

import Spacer from 'components/Spacer'

import Container, { FieldGroup, Error } from './styles'

function TextArea({ config, formik }) {
  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty(),
  )
  const { label, labelwidth, name, stacked } = config
  const error = formik.errors[name]

  function handleChange(state) {
    setEditorState(state)
    if (state.getCurrentContent().getPlainText().length > 0) {
      formik.setFieldValue(name, stateToHTML(state.getCurrentContent()))
    } else {
      formik.setFieldValue(name, '')
    }
  }

  return (
    <Container>
      <FieldGroup width={labelwidth} className={`${stacked ? 'stacked' : ''}`}>
        <label className={`${error ? 'error' : ''}`} htmlFor={name}>
          {label}
        </label>
        <div className={`text-editor ${error ? 'error' : ''}`}>
          <Editor
            editorState={editorState}
            onChange={handleChange}
            placeholder={config.placeholder}
          />
        </div>
      </FieldGroup>
      <Error>{error}</Error>
      <Spacer height={10} />
    </Container>
  )
}

export default TextArea
